// coupon.tsx
import React, { useState, useEffect } from 'react';
import { Card, Typography, Button, message, Flex } from 'antd';
import {
  CopyOutlined,
  CheckOutlined,
  FireOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import './coupon.scss';

const { Text } = Typography;

const CouponDisplay = () => {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState(
    dayjs().add(1, 'day').subtract(5, 'minutes').diff(dayjs(), 'second')
  );
  const [copied, setCopied] = useState(false);
  const couponCode = 'NINJA20';

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const days = Math.floor(seconds / (3600 * 24));
    const hours = Math.floor((seconds % (3600 * 24)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${days}d ${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(couponCode);
    setCopied(true);
    message.success(t('billing.coupon.copied'));
    setTimeout(() => setCopied(false), 2000);
  };

  if (timeLeft <= 0) {
    return null;
  }

  return (
    <Card className="coupon-card-compact">
      <Flex align="center" justify="space-between" wrap="wrap" gap={16}>
        {/* Left: Flash Sale Info */}
        <Flex align="center" gap={12}>
          <div className="fire-icon-compact">
            <FireOutlined />
          </div>
          <div>
            <Text strong style={{ color: '#ff4d4f', fontSize: '16px' }}>
              {t('billing.coupon.flashSale')}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: '12px' }}>
              {t('billing.coupon.endSoon')}
            </Text>
          </div>
        </Flex>

        {/* Middle: Countdown */}
        <Flex align="center" gap={8} className="countdown-compact">
          <ClockCircleOutlined style={{ fontSize: '16px', color: '#ff4d4f' }} />
          <Text
            strong
            style={{
              fontSize: '18px',
              color: '#ff4d4f',
              fontFamily: 'monospace',
            }}
          >
            {formatTime(timeLeft)}
          </Text>
        </Flex>

        {/* Right: Coupon Code & Copy */}
        <Flex align="center" gap={12} className="coupon-action">
          <div className="coupon-code-compact">{couponCode}</div>
          <Button
            type="primary"
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={copyToClipboard}
            className={copied ? 'copied' : ''}
          >
            {copied
              ? t('billing.coupon.copiedButton')
              : t('billing.coupon.copyButton')}
          </Button>
        </Flex>
      </Flex>

      {/* Footer Note */}
      <div style={{ marginTop: '12px', textAlign: 'center' }}>
        <Text type="danger" style={{ fontSize: '11px' }}>
          {t('billing.coupon.applyNote')}
        </Text>
      </div>
    </Card>
  );
};

export default CouponDisplay;
